import { array, boolean, mixed, number, object, string } from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { Roles } from "@utils/settings";
import {
  DietitianClinicListResource,
  dietitianClinicListResourceSchema,
} from "@client/resources/ClinicDietitianResource";
import { DietitianFacilityDto, PhoneDto } from "@client/common";

export const fetchClinicDietitians = async (): Promise<
  ApiResponse<DietitianClinicListResource[]>
> => {
  const response = await fetchData(
    "/dietitian/clinic/dietitians",
    APIMethods.GET,
  );
  return await fetchClinicDietitiansSchema.validate(response);
};

export interface ClinicDietitianDto {
  id: number;
  active: boolean;
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles[];
  avatar?: string;
  facility?: DietitianFacilityDto;
  clientsCount: number;
  phone: PhoneDto;
}

const fetchClinicDietitiansSchema = object({
  data: array(dietitianClinicListResourceSchema).required(),
});
